export class LoadPermissionsSuccess {
  static readonly type = '[Permissions] Load Permissions Success';
  constructor(public permissions: string[]) {}
}
